import { merge } from "lodash";
import ReactApexChart from "react-apexcharts";
// material
import { useTheme, styled } from "@mui/material/styles";
import { Card, CardHeader } from "@mui/material";
//
import { BaseOptionChart } from "../../elements/charts";

import { useEffect, useState } from "react";

import { axios } from "../../../commons";

// ----------------------------------------------------------------------

const CHART_HEIGHT = 392;
const LEGEND_HEIGHT = 72;

const ChartWrapperStyle = styled("div")(({ theme }) => ({
  height: CHART_HEIGHT,
  marginTop: theme.spacing(2),
  "& .apexcharts-canvas svg": {
    height: CHART_HEIGHT,
  },
  "& .apexcharts-canvas svg,.apexcharts-canvas foreignObject": {
    overflow: "visible",
  },
  "& .apexcharts-legend": {
    height: LEGEND_HEIGHT,
    alignContent: "center",
    position: "relative !important",
    borderTop: `solid 1px ${theme.palette.divider}`,
    top: `calc(${CHART_HEIGHT - LEGEND_HEIGHT}px) !important`,
  },
}));

// ----------------------------------------------------------------------

const CHART_DATA = [
  { name: "~10s", data: [2, 5, 1, 2, 0, 3] },
  { name: "20s", data: [4, 2, 7, 3, 1, 1] },
  { name: "30s", data: [2, 5, 6, 1, 7, 5] },
  { name: "40s", data: [1, 7, 2, 5, 1, 1] },
  { name: "50s", data: [3, 9, 3, 2, 8, 2] },
  { name: "60s~", data: [4, 2, 4, 6, 2, 0] },
];

export default function AppUserAgeDiagnosis() {
  const [userAgeDiagnosis, setUserAgeDiagnosis] = useState(CHART_DATA);
  const theme = useTheme();

  async function getUserAgeDiagnosis() {
    try {
      const { data } = await axios.get(
        `/admin/users/dashboard/userAgeDiagnosis`
      );
      console.log("data", data);
      setUserAgeDiagnosis(data);
    } catch (err) {
      console.error(err);

      if (err.response) {
        alert(err.response.data.error);
      }
    }
  }

  useEffect(() => {
    getUserAgeDiagnosis();
  }, []);

  const chartOptions = merge(BaseOptionChart(), {
    stroke: { width: 2 },
    fill: { opacity: 0.48 },
    legend: { floating: true, horizontalAlign: "center" },
    xaxis: {
      categories: [
        "k07.60", // 턱관절내장증
        "k07.66", // 저작근의 장애
        "k07.65", // 턱관절의 퇴행성관절염
        "k07.62", // 턱관절의 재발성 탈구 및 아탈구
        "k07.68", // 기타 명시된 턱관절장애
        "ETC", // 그외 질환(직접입력)
      ],
      labels: {
        style: {
          colors: [
            theme.palette.text.secondary,
            theme.palette.text.secondary,
            theme.palette.text.secondary,
            theme.palette.text.secondary,
            theme.palette.text.secondary,
            theme.palette.text.secondary,
          ],
        },
      },
    },
  });

  return (
    <Card>
      <CardHeader title="Diagnosis of UserAge" />
      <ChartWrapperStyle dir="ltr">
        <ReactApexChart
          type="radar"
          series={userAgeDiagnosis}
          options={chartOptions}
          height={340}
        />
      </ChartWrapperStyle>
    </Card>
  );
}
